import React, { useEffect, useState } from "react";
import NeoPage from "../page/Page";
import Container from "@mui/material/Container";
import NeoDrawer from "./drawer/DashboardDrawer";
import NeoDashboardHeader from "./header/DashboardHeader";
import { createDriver, Neo4jProvider, useConnection } from "use-neo4j";
import {
  applicationGetConnection,
  applicationHasAboutModalOpen,
} from "../application/ApplicationSelectors";
import { connect } from "react-redux";
import _ from "lodash";
import NeoDashboardConnectionUpdateHandler from "../component/misc/DashboardConnectionUpdateHandler";
import { forceRefreshPage } from "../page/PageActions";
import { getPageNumber } from "../settings/SettingsSelectors";
import { createNotification } from "../application/ApplicationActions";
import { createNotificationThunk } from "../page/PageThunks";
import { downloadComponentAsImage } from "../chart/util/ChartUtils";
import Fab from "@mui/material/Fab";
import NoeThemeSwitch from "../component/model/NeoThemeSwitch";

const Dashboard = ({
  pagenumber,
  connection,
  onConnectionUpdate,
  onDownloadDashboardAsImage,
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);  // Start closed
  const [openThemeSwitch, setOpenThemeSwitch] = useState(false);
  const [showLoadTooltip, setShowLoadTooltip] = useState(false);
  const [showSearchTooltip, setShowSearchTooltip] = useState(false);

  // Open drawer after component mounts (animated effect)
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setDrawerOpen(true);
  //   }, 2000); // 2000ms delay for smooth opening animation

  //   return () => clearTimeout(timer);
  // }, []);

  // Show tooltips after connection is established
  useEffect(() => {
    const hasSeenWelcomeTooltips = localStorage.getItem('hasSeenWelcomeTooltips');
    if (!hasSeenWelcomeTooltips && connection?.database) {
      const timer = setTimeout(() => {
        setShowLoadTooltip(true);
        setShowSearchTooltip(true);

        // Auto-hide after 8 seconds
        setTimeout(() => {
          setShowLoadTooltip(false);
          setShowSearchTooltip(false);
          localStorage.setItem('hasSeenWelcomeTooltips', 'true');
        }, 12000);
      }, 2000); // Show 3 seconds after connection

      return () => clearTimeout(timer);
    }
  }, [connection?.database]);
  const driver = createDriver(
    connection.protocol,
    connection.url,
    connection.port,
    connection.username,
    connection.password
  );

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };
  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleOpenThemeSwitch = () => {
    setOpenThemeSwitch(true);
  };

  const content = (
    <Neo4jProvider driver={driver}>
      <NeoDashboardConnectionUpdateHandler
        pagenumber={pagenumber}
        connection={connection}
        onConnectionUpdate={onConnectionUpdate}
      />
      <NeoDrawer
        open={drawerOpen}
        handleDrawerClose={handleDrawerClose}
        showLoadTooltip={showLoadTooltip}
        setShowLoadTooltip={setShowLoadTooltip}
      />
      <NoeThemeSwitch open={openThemeSwitch} setOpen={setOpenThemeSwitch} />
      <NeoDashboardHeader
        open={drawerOpen}
        connection={connection}
        onDownloadImage={onDownloadDashboardAsImage}
        handleDrawerOpen={handleDrawerOpen}
        showLoadTooltip={showLoadTooltip}
        showSearchTooltip={showSearchTooltip}
        setShowLoadTooltip={setShowLoadTooltip}
        setShowSearchTooltip={setShowSearchTooltip}
      />
      {/* <Fab
        color="primary"
        sx={{ position: "absolute", bottom: 16, right: 16 }}
        onClick={handleOpenThemeSwitch}
      >
        Theme
      </Fab> */}

      <main
        style={{
          flexGrow: 1,
          height: "100vh",
          overflow: "auto",
          backgroundColor: "#ffffff",
        }}
      >
        <Container maxWidth={false} style={{ marginTop: "70px", width: "100%" }}>
          <NeoPage />
        </Container>
      </main>
    </Neo4jProvider>
  );
  return content;
};

const mapStateToProps = (state) => ({
  connection: applicationGetConnection(state),
  pagenumber: getPageNumber(state),
});

const mapDispatchToProps = (dispatch) => ({
  onConnectionUpdate: (pagenumber) => {
    dispatch(
      createNotificationThunk(
        "Connection Updated",
        "You have updated your Neo4j connection, your reports have been reloaded.",
      )
    );
    dispatch(forceRefreshPage(pagenumber));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
